import React, { ReactNode, createContext, useContext, useState } from "react";

interface ContextType {
  addModalVisible: boolean;
  setAddModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  //
  addModalWhatsAppVisible: boolean;
  setAddModalWhatsAppVisible: React.Dispatch<React.SetStateAction<boolean>>;
  //
  addModalWhatsAppMetaVisible: boolean;
  setAddModalWhatsAppMetaVisible: React.Dispatch<React.SetStateAction<boolean>>;
  //
  addModalFacebookVisible: boolean;
  setAddModalFacebookVisible: React.Dispatch<React.SetStateAction<boolean>>;
  //
  addModalGoogleDriveVisible: boolean;
  setAddModalGoogleDriveVisible: React.Dispatch<React.SetStateAction<boolean>>;
  //
  addModalFacebookMetaVisible: boolean;
  setAddModalFacebookMetaVisible: React.Dispatch<React.SetStateAction<boolean>>;
  /** The Meta form being edited, or null when linking a new one */
  facebookMetaEditFormId: string | null;
  setFacebookMetaEditFormId: React.Dispatch<
    React.SetStateAction<string | null>
  >;
}

const Context = createContext<ContextType | undefined>(undefined);

export const useIntegrationContext = () => {
  const context = useContext(Context);

  if (!context) {
    throw new Error(
      "useIntegrationContext must be used within a IntegrationContextProvider",
    );
  }

  return context;
};

interface Props {
  children: ReactNode;
}

export const IntegrationContextProvider: React.FC<Props> = ({ children }) => {
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [addModalWhatsAppVisible, setAddModalWhatsAppVisible] = useState(false);
  const [addModalFacebookVisible, setAddModalFacebookVisible] = useState(false);
  const [addModalWhatsAppMetaVisible, setAddModalWhatsAppMetaVisible] =
    useState(false);
  const [addModalGoogleDriveVisible, setAddModalGoogleDriveVisible] =
    useState(false);
  const [addModalFacebookMetaVisible, setAddModalFacebookMetaVisible] =
    useState(false);
  const [facebookMetaEditFormId, setFacebookMetaEditFormId] = useState<
    string | null
  >(null);

  return (
    <Context.Provider
      value={{
        addModalVisible,
        setAddModalVisible,
        addModalWhatsAppVisible,
        setAddModalWhatsAppVisible,
        addModalFacebookVisible,
        setAddModalFacebookVisible,
        addModalWhatsAppMetaVisible,
        setAddModalWhatsAppMetaVisible,
        addModalGoogleDriveVisible,
        setAddModalGoogleDriveVisible,
        addModalFacebookMetaVisible,
        setAddModalFacebookMetaVisible,
        facebookMetaEditFormId,
        setFacebookMetaEditFormId,
      }}
    >
      {children}
    </Context.Provider>
  );
};
